import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { splitAsyncAction } from '../utils';
import { IDSDropdownResponse } from './types';
import { log404ErrorAsWarning } from 'Common/apiAdapters/ErrorHandlers';

export const fetchIdsDropdownDataAction = createAsyncAction(
    '@IDS_DROPDOWN/FETCH_START',
    '@IDS_DROPDOWN/FETCH_SUCCESS',
    '@IDS_DROPDOWN/FETCH_FAILURE'
)<FetchAction, SuccessFetchActionPayload<IDSDropdownResponse>, DefaultErrorPayload>();

export const fetchIdsDropdownData = (): DataFetchingThunkAction => async (dispatch, _, { apiService, logger }) => {
    const identifier = 'IDS_DROPDOWN';
    dispatch(fetchIdsDropdownDataAction.request({ identifier }));
    try {
        const response = await apiService.shopApi.getIdsDropdownData();
        dispatch(fetchIdsDropdownDataAction.success({ identifier, data: response }));
    } catch (error) {
        log404ErrorAsWarning(error, identifier, logger, 'IDS_DROPDOWN');
        dispatch(fetchIdsDropdownDataAction.failure({ identifier, error }));
    }
};

export const idsDropdownActions = [...splitAsyncAction(fetchIdsDropdownDataAction)];

export type IDSDropdownActionType = ActionType<typeof fetchIdsDropdownDataAction>;
